import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoodHealthColored = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "excellentHealth",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_896",
		"data-name": "Group 896",
		transform: "translate(4 2)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2500",
				"data-name": "Path 2500",
				d: "M8,4,9.3,2.375A1,1,0,0,1,10.081,2H13.92a1,1,0,0,1,.781.375L16,4h0V5a1,1,0,0,1-1,1H9A1,1,0,0,1,8,5V4Z",
				transform: "translate(-4 -2)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2501",
				"data-name": "Path 2501",
				d: "M9.667,9.333,8,11,7,10",
				transform: "translate(-4 -2)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2502",
				"data-name": "Path 2502",
				d: "M13,10h3",
				transform: "translate(-4 -2)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2503",
				"data-name": "Path 2503",
				d: "M11.191,20H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H8",
				transform: "translate(-4 -2)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2504",
				"data-name": "Path 2504",
				d: "M16,4h2a2,2,0,0,1,2,2V9.684",
				transform: "translate(-4 -2)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2511",
				"data-name": "Path 2511",
				d: "M7,15h3",
				transform: "translate(-4 -2)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12726",
				"data-name": "Path 12726",
				d: "M12,15.425l2.4,1.251a.636.636,0,0,0,.924-.666l-.458-2.651,1.942-1.877a.631.631,0,0,0-.353-1.078l-2.683-.387L12.571,7.6a.639.639,0,0,0-1.142,0l-1.2,2.414L7.546,10.4a.631.631,0,0,0-.353,1.078l1.942,1.877L8.677,16.01a.636.636,0,0,0,.924.666L12,15.425",
				transform: "translate(2 2.75)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_2512",
		"data-name": "Path 2512",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgGoodHealthColored;
